class MaterialsDrawer extends HTMLElement {
  constructor() {
    super();

    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.updateVariant = this.updateVariant.bind(this);
    this.init = this.init.bind(this);
    
    const showDetailsBtn = document.querySelector('.js-show-materials-info');
    if (showDetailsBtn) {
      showDetailsBtn.addEventListener('click', () => {
        document.querySelector('.js-materials-drawer').open(showDetailsBtn);
      });
    }

    // Initial setup
    this.init();
    
    document.addEventListener('shopify:section:load', (event) => {
      // Check if this section was reloaded
      if (event.target.contains(this)) {
        this.init();
      }
    });
  }

  handleVariantChange() {
    this.getMaterials()
  }

  init() {
     // Setup update variant button
     const updateVariantBtns = this.querySelectorAll(".updateParallelVariant");
     if (updateVariantBtns.length > 0) {
      //* Remove any existing listeners to prevent duplicates*
      updateVariantBtns.forEach(updateVariantBtn => {
        updateVariantBtn.removeEventListener('click', this.updateVariant);
        updateVariantBtn.addEventListener('click', this.updateVariant);
      });
    }
  }

  async getMaterials() {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('sections', 'materials-drawer');
    const updatedUrl = currentUrl.toString();

    try {
      const response = await fetch(updatedUrl);
      const data = await response.json();
      
      const template = document.createElement('template');
      template.innerHTML = data["materials-drawer"];
      
      const selectorsForRefresh = ['.drawer'];
      for (let i = 0; i < selectorsForRefresh.length; i += 1) {
        const newEl = template.content.querySelector(selectorsForRefresh[i]);
        const currentEl = this.querySelector(selectorsForRefresh[i]);
        if (currentEl && newEl) {
          currentEl.innerHTML = newEl.innerHTML;
        }
      }

      // Reinitialize buttons after content update
      this.init();
    } catch (error) {
      console.error('Error fetching materials:', error);
    }
  }

  updateVariant(event) {
    const splitSwatches = document.querySelectorAll('.option-selector__slider .opt-btn');
    const material = event.target.dataset.material;
    console.log("material", material)
    const materialLabel = document.querySelector(`label[data-swatch="${material}"]`);
    console.log("materialLabel", materialLabel)
    if (materialLabel) {
      materialLabel.click();
    }
  }
}

customElements.define('materials-drawer', MaterialsDrawer);
